// extracted by mini-css-extract-plugin
export default {"userFormModal":"userFormModal_userFormModal__hUriS","btnContainer":"userFormModal_btnContainer__DUrFH"};